import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { IAboutApartmentData, IAboutApartmentTranslation } from '@/types';
import { SimpleDescription, ValueView } from '@/components';
import './style.styl';

@Component({
  name: 'AboutApartmentCommon',
})
export default class AboutApartmentCommon extends Vue {
  @Prop({type: Object, default: () => {}})
    public readonly characteristic!: IAboutApartmentTranslation['apartment_characteristic'];
  @Prop({type: Object, default: () => {}})
    public readonly description!: IAboutApartmentTranslation['apartment_description'];
  @Prop({type: Object, default: () => {}})
    public readonly data!: IAboutApartmentData;
  @Prop({type: Boolean, default: false}) public readonly mobile!: boolean;

  private mapped: string[] = [
    'building', 'rooms', 'floor', 'area',
  ];

  private render(createElement: CreateElement): VNode {

    const apartmentCharacteristic: VNode = createElement('div', {
      class: ['flex-column', 'flex-left'],
    }, [
      createElement('p', {
        class: 'p5',
      }, this.data.design),
      createElement(this.mobile ? 'h6' : 'h5', this.data.title),
      createElement('div', {
        class: 'common-item-wrapper',
      }, [
        !!this.data && this.mapped.map((item) => {
          return createElement(ValueView, {
            class: 'apartment-common-item',
            props: {
              name: this.characteristic[item],
              value: this.data[item],
            },
          });
        }),
      ]),
      !this.mobile && createElement('div', { class: 'line'}),
      !this.mobile && createElement(ValueView, {
        props: {
          name: this.characteristic.apartment_street_view,
          value: this.data.views.length === 1
            ? this.data.views[0].name
            : this.data.views.length && this.data.views.reduce((accumulator, currentValue, index, array) => {
            return accumulator.name + '  /  '  + currentValue.name;
          }),
        },
      }),
      createElement('div', { class: 'line'}),
      createElement(SimpleDescription, {
        props: {
          title: this.description.title,
          description: this.data.description,
        },
      }),
    ]);

    const container: VNode[] = [
      createElement('div', {
        class: [this.mobile && 'mobile'],
      }, [apartmentCharacteristic]),
      createElement('div', {
        class: ['flex-center', this.mobile && 'mobile'],
      }, this.$slots.action),
    ];

    return createElement('div', {
      attrs: {
        id: 'apartment-common',
      },
      class: ['flex-center', this.mobile && 'flex-column'],
    }, [container]);
  }
}
